<template>
  <span @click="open">
    <slot name="trigger"></slot>
  </span>
</template>

<script>
export default {
  props: ["component", "props"],

  methods: {
    open() {
      this.$buefy.modal.open({
        component: this.component,
        props: this.props,
        width: 840,
        hasModalCard: true
      });
    }
  }
};
</script>
